import { render, staticRenderFns } from "./wlncustomer.vue?vue&type=template&id=ece8b3c8&scoped=true&"
import script from "./wlncustomer.vue?vue&type=script&lang=js&"
export * from "./wlncustomer.vue?vue&type=script&lang=js&"
import style0 from "./wlncustomer.vue?vue&type=style&index=0&id=ece8b3c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece8b3c8",
  null
  
)

export default component.exports